import AddressFindEnumDTO from "features/shared/enums/dynamic/AddressFindEnumDTO";
import _ from "lodash";

export const getFormAddress = (
  findAddress: AddressFindEnumDTO
): AddressFindEnumDTO => {
  // this values doesn't contain form
  return _.omit(findAddress, [
    "township",
    "region",
    "stateName",
  ]);
};

export const getFormAddressKeys = (objectPrefix: string): string[] => {
  // all keys except countryCode
  const keys = [
    "street",
    "evidenceNumber",
    "houseNumber",
    "evidenceNumberType",
    "zipCode",
    "cityPart",
    "city",
    // cadstral info
    "cadastralTerritory",
    "parcelNumber"
  ];

  return keys.map((key) => `${objectPrefix}.${key}`);
};
